import { fbt } from 'fbtee'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog'
import { MemberInterestList } from './MemberInterestList'
import type { UserProfile } from '../types'
import type { TicketMarks } from '../hooks/useTicketMarksByEvent'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  interestedMemberIds: string[]
  goingMemberIds: string[]
  tentativeIds?: string[]
  profiles: Record<string, UserProfile>
  currentUserId?: string | null
  name?: string
  subtitle?: string
  pregameGoerIds?: ReadonlySet<string>
  tickets?: TicketMarks
}

export function MemberInterestDialog({
  open,
  onOpenChange,
  interestedMemberIds,
  goingMemberIds,
  tentativeIds,
  profiles,
  currentUserId,
  name,
  subtitle,
  pregameGoerIds,
  tickets,
}: Props) {
  if (goingMemberIds.length === 0 && interestedMemberIds.length === 0 && !tentativeIds?.length) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="max-h-[75vh] overflow-hidden flex flex-col">
        <DialogHeader className="shrink-0">
          <DialogTitle className="pr-6 break-words leading-snug">{name ?? fbt("Who's interested", 'Dialog title showing who is interested in an artist or set')}</DialogTitle>
          {subtitle && <p className="text-sm text-muted-foreground pr-6 break-words">{subtitle}</p>}
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto">
          <MemberInterestList
            interestedMemberIds={interestedMemberIds}
            goingMemberIds={goingMemberIds}
            tentativeIds={tentativeIds}
            profiles={profiles}
            currentUserId={currentUserId}
            pregameGoerIds={pregameGoerIds}
            tickets={tickets}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
